import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable, take } from 'rxjs'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { SearchBoxComponentService } from '../../search-box/search-box-component.service'
import { ActivatedRoute, Router } from '@angular/router'
import { PDPService } from '../services/pdp.services'
import { Product } from '../../../models/product.model'
import { CommonService } from '../../../shared/services/common.service'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
import { Discounts } from '../../../models/discounts.model'
import {
  Ecommerce,
  GTMDataLayer,
} from '../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'vs-custom-product-intro',
  templateUrl: './custom-product-intro.component.html',
  styleUrls: ['./custom-product-intro.component.scss'],
})
export class CustomProductIntroComponent implements OnInit, OnDestroy {
  product$: Observable<Product | any> = this.currentProductService.getProduct()
  product: any
  openMenu = false
  userType: string
  loggedIn: boolean
  obsoleteProductMsg = true
  count = 1
  id: any
  routeFrom = ItemListTypeEnum.ProductListing;
  // public product$: Observable<any>;

  constructor(
    private currentProductService: CurrentProductService,
    private auth: AuthService,
    private commonService: CommonService,
    private pdpService: PDPService,
    private activatedRoute: ActivatedRoute,
    private globalMessageService: GlobalMessageService,
    private searchBoxComponentService: SearchBoxComponentService,
    private router: Router,
    public spinnerOverlayService: SpinnerOverlayService,
    private cd: ChangeDetectorRef,
    private gtmService: GoogleTagManagerService
  ) {}
  ngOnInit(): void {
    this.spinnerOverlayService.show()
    // this.activatedRoute.paramMap.subscribe((value:any) =>{
    // this.id =value.params.productCode});
    // this.product$ = this.pdpService.getProduct(this.id);
    // this.pdpService.setProductId(this.id);
    this.product$.subscribe((response) => {
      this.product = response;
      console.log("product$: ", this.product);
      
      if (!this.spinnerOverlayService.getOverlayRef().hasAttached()) {
        this.spinnerOverlayService.show();
      }
      if (response !== null && response['errorCode'] === '400') {
        this.globalMessageService.add(
          { key: 'pdp.productNotAccessible' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
        this.router.navigate(['/page-not-found'])
      }
      this.spinnerOverlayService.hide()
      this.cd.detectChanges()
    })

    this.product$.pipe(
      take(1)
    ).subscribe((res) => {
      this.setProductDetails(res);
    });

    this.commonService.passPriceAndAvailablityProductCount.subscribe(
      (data: any) => {
        this.product$ = data
      }
    )
    this.commonService.showPriceCount = true
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.loggedIn = true
        this.userType = 'current'
      } else {
        this.loggedIn = false
        this.userType = 'anonymous'
      }
    })
    this.commonService.passCount.subscribe((count) => {
      if (count >= 1 && this.commonService.showPriceCount) {
        this.count = 1
      } else {
        this.count = count
      }
      this.commonService.showPriceCount = false
    })
    this.searchBoxComponentService.inSearchFlowOnly.next(false)
  }

  setProductDetails(product){
    if (product !== null && product !== undefined) {
      const viewItemDataLayer: GTMDataLayer = {
        event: GtmEvents.ViewItem,
        ecommerce: {
          currency: product?.netPrice?.currencyIso || '',
          value: product?.netPrice?.value || '',
          items: [
            {
              item_id: product?.code,
              item_name: product?.name,
              index: 0,
              item_category: product?.categories[0]?.name || '',
              item_category2: product?.categories[1]?.name || '',
              item_category3: product?.categories[2]?.name || '',
              item_category4: product?.categories[3]?.name || '',
              item_category5: product?.categories[4]?.name || '',
              item_list_id: ItemListTypeEnum.ProductDetail,
              item_list_name: ItemListTypeEnum.ProductDetail,
              price: product?.netPrice?.value
            },
          ],
        },
      };
      
      if (
        product &&
        product?.estShipData &&
        product?.estShipData[0]?.stockQty
      ) {
        viewItemDataLayer.ecommerce.items[0].quantity = Number(
        product?.estShipData[0]?.stockQty
        );
      }

      this.gtmService.sendEvent(viewItemDataLayer);
    }
  }

  getTotalDiscounts(discounts, adder?) {
    let totalDisc = 0

    for (const disc of discounts) {
      totalDisc += disc.value
    }
    return (totalDisc - adder).toFixed(2)
  }
  getDiscountName(code) {
    return Discounts[code]
  }
  openBreakup() {
    this.openMenu = !this.openMenu
  }
  closeMenu(event) {
    this.openMenu = false
  }
  closeObsolete() {
    this.obsoleteProductMsg = false
  }
  toggleMenu() {
    this.openMenu = !this.openMenu
  }
  ngOnDestroy() {
    this.count = 1
    this.commonService.getCount(this.count)
  }
}
